import { FieldShell } from '../FieldShell'
import type { FieldComponentProps } from '../rendererContext'
import type { DateConfig } from '../types'
import { controlClass, useControlMeta } from './useControlMeta'

export function DateField({ field, path, value, errors }: FieldComponentProps) {
  const meta = useControlMeta(field, path, errors)
  const config = field.config as DateConfig | undefined
  const inputType = config?.variant === 'datetime' ? 'datetime-local' : 'date'

  if (field.display_only) {
    return (
      <FieldShell field={field} path={path} errors={errors}>
        <div id={meta.id} className="form-control-plaintext">
          {value == null ? '' : String(value)}
        </div>
      </FieldShell>
    )
  }

  return (
    <FieldShell field={field} path={path} errors={errors}>
      <input
        id={meta.id}
        type={inputType}
        className={controlClass('form-control', meta.classNames.control, meta.hasErrors)}
        value={value == null ? '' : String(value)}
        min={config?.min}
        max={config?.max}
        disabled={meta.disabled}
        aria-invalid={meta.ariaInvalid}
        aria-required={meta.ariaRequired}
        aria-describedby={meta.describedBy}
        onChange={(event) => meta.setFieldValue(path, event.target.value === '' ? undefined : event.target.value)}
        onBlur={() => meta.notifyBlur(path)}
      />
    </FieldShell>
  )
}
